import React, { useState, useRef, useEffect } from 'react';
import '../styles/LiquidSelector.css';

const LiqSelArr = ({
  options = [],
  value,
  onChange,
  className = '',
  placeholder = "Выберите вариант",
  getOptionLabel = (option) => option?.name || String(option),
  getOptionValue = (option) => option?._id || option,
  disabled = false,
  required = false,
  id,
  name
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Закрытие dropdown при клике вне компонента
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Динамический z-index для предотвращения наложения
  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      // Устанавливаем высокий z-index когда открыт
      dropdownRef.current.style.zIndex = '10000';
    } else if (dropdownRef.current) {
      // Возвращаем обычный z-index когда закрыт
      dropdownRef.current.style.zIndex = '100';
    }
  }, [isOpen]);

  // Гарантируем, что options всегда массив
  const safeOptions = Array.isArray(options) ? options : [];

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const selectedOptionLabel = value ? getOptionLabel(value) : '';

  return (
    <div 
      ref={dropdownRef}
      className={`selectorConteiner ${isOpen ? 'selectorOpen' : ''} ${disabled ? 'selectorDisabled' : ''}`}
    >
      <div 
        className={`selectorContainerBg ${className} ${isOpen ? 'bgOpen' : ''}`}
        onClick={toggleDropdown}
      >
        <div className="selectedValue">
          {selectedOptionLabel || placeholder}
        </div>
        <div className={`dropdownArrow ${isOpen ? 'arrowOpen' : ''}`}>
          ▼
        </div>
      </div>

      {/* Options dropdown */}
      <div className={`optionsDropdown ${isOpen ? 'optionsOpen' : ''}`}>
        {safeOptions.map((option, index) => {
          const optionValue = getOptionValue(option);
          const optionLabel = getOptionLabel(option);
          const isSelected = value && getOptionValue(value) === optionValue;
          
          return (
            <div
              key={optionValue || index}
              className={`optionItem ${isSelected ? 'optionSelected' : ''}`}
              onClick={() => handleOptionClick(option)}
            >
              {optionLabel}
            </div>
          );
        })}
        
        {/* Сообщение если options пуст */}
        {safeOptions.length === 0 && (
          <div className="optionItem optionDisabled">
            Нет доступных мероприятий
          </div>
        )}
      </div>
    </div>
  );
};

export default LiqSelArr;